import ApiErrorCodes from '@/constants/api/ApiErrorCodes'
import HttpStatusCodes from '@/constants/api/HttpStatusCodes'
// eslint-disable-next-line no-unused-vars
import ErrorResponseDTO from '@/models/error/errorResponseDTO'

// Factory

/**
 * Factory to handle generating error messages for certification actions
 * @param {{actionName: String, error: ErrorResponseDTO, i18n: {t: Function}}} payload
 * @returns
 */
export function CertificationActionErrorMessageFactory({
  actionName,
  error,
  i18n,
}) {
  switch (actionName) {
    case 'deleteCertification':
      return deleteCertificationActionErrorMessageHandler({ error, i18n })
    default:
      return error?.message
  }
}

// Handlers

/**
 * Generate error message for the deleteCertification store action
 * @param {{error: ErrorResponseDTO, i18n: {t: Function}}} payload
 * @returns
 */
const deleteCertificationActionErrorMessageHandler = ({ error, i18n }) => {
  let errorMessage = error.message

  switch (error?.error?.response?.status) {
    case HttpStatusCodes.NotFound:
      errorMessage = i18n.t('certifications.error.notFound')
      break
    case HttpStatusCodes.BadRequest:
      if (error.code === ApiErrorCodes.Certifications.CannotDeleteVerified)
        errorMessage = i18n.t('certifications.view.deleteDisabledTooltip')
      break
  }

  return errorMessage
}
